import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
/**
 * Whether a job is still releasable — the same rule `assertManufacturingOrderIsDraft` enforces
 * under its row lock, so the screen offers Release exactly when the mutation would accept it.
 */
export function canReleaseManufacturingOrder(statusId) {
    return statusId === ManufacturingLifecycleStatus.DRAFT;
}
//# sourceMappingURL=can-release-manufacturing-order.js.map